import { StepName } from '../../Types/interfaces';

export interface ProcessStepDefinition {
  stepName: StepName;
  titleKey: string;
  // whether the Roll back button is shown when this is the last done step of its column
  canRollback: boolean;
  // steps of the other column that depend on this one, while one of them is done
  // this step can't be rolled back
  blockedBy?: StepName[];
  // a step of a signing chain: the signatures are drawn (ink), they can't be removed one by one,
  // so rolling it back removes every signature and the signing starts again with the first signer
  resetsSigning?: boolean;
}

// same order and titles as the student's InternshipProcessComponent.
// "Accepting internship by organization" is not a process step (it comes from
// the application status), so it is rendered separately before these
export const ORGANIZATION_STEPS: ProcessStepDefinition[] = [
  {
    stepName: StepName.workSafetyInstructionReading,
    titleKey: 'internshipProcessComp.signWorkSafety',
    canRollback: true,
  },
  {
    stepName: StepName.allocatingTutorFromOrganization,
    titleKey: 'internshipProcessComp.assignMentor',
    canRollback: true,
  },
  {
    stepName: StepName.workReportFilling,
    titleKey: 'internshipProcessComp.fillWorkReport',
    canRollback: true,
  },
  {
    stepName: StepName.validateWorkReportByTutor,
    titleKey: 'internshipProcessComp.validateWorkReportByTutor',
    canRollback: true,
  },
  {
    stepName: StepName.signingWorkReportByStudent,
    titleKey: 'internshipProcessComp.signWorkReportByStudent',
    canRollback: true,
    resetsSigning: true,
  },
  {
    stepName: StepName.signingWorkReportByTutor,
    titleKey: 'internshipProcessComp.signWorkReportByTutor',
    canRollback: true,
    resetsSigning: true,
  },
  {
    stepName: StepName.completingEvaluationReportByOrganization,
    titleKey: 'internshipProcessComp.completeEvaluationByOrganization',
    canRollback: true,
  },
  {
    stepName: StepName.signingEvaluationReportByTutor,
    titleKey: 'internshipProcessComp.signEvaluationReportByTutor',
    canRollback: true,
    // grading needs both the signed evaluation report and the convention signed by the rector
    blockedBy: [StepName.gradingWorkReportByUniversitySupervisor],
  },
];

export const UNIVERSITY_STEPS: ProcessStepDefinition[] = [
  {
    stepName: StepName.allocatingUniversitySupervisorFromUBB,
    titleKey: 'internshipProcessComp.selectSupervisor',
    canRollback: true,
  },
  {
    stepName: StepName.registeringConventionDocument,
    titleKey: 'internshipProcessComp.registeringConvention',
    canRollback: true,
  },
  {
    stepName: StepName.conventionFillingAndSigningByStudent,
    titleKey: 'internshipProcessComp.fillConventionByStudent',
    canRollback: true,
    resetsSigning: true,
  },
  {
    stepName: StepName.signingInternshipConventionByOrganization,
    titleKey: 'internshipProcessComp.signConventionByOrganization',
    canRollback: true,
    resetsSigning: true,
  },
  {
    // university organizations: the project coordinator signs instead of the organization
    stepName:
      StepName.SigningInternshipConventionByUniversityProjectCoordinator,
    titleKey:
      'internshipProcessComp.signConventionByUniversityProjectCoordinator',
    canRollback: true,
    resetsSigning: true,
  },
  {
    stepName: StepName.signingInternshipConventionByTutor,
    titleKey: 'internshipProcessComp.signConventionByTutor',
    canRollback: true,
    resetsSigning: true,
  },
  {
    stepName: StepName.signingInternshipConventionByUniversitySupervisor,
    titleKey: 'internshipProcessComp.signConventionBySupervisor',
    canRollback: true,
    resetsSigning: true,
  },
  {
    stepName: StepName.signingInternshipConventionByRector,
    titleKey: 'internshipProcessComp.signConventionByRector',
    canRollback: true,
    resetsSigning: true,
  },
  {
    stepName: StepName.gradingWorkReportByUniversitySupervisor,
    titleKey: 'internshipProcessComp.gradeWorkReportBySupervisor',
    canRollback: true,
  },
];
